<template>
  <modal
    v-slot="{ data }"
    name="deliveryNotAvailable"
    modal-style="compact"
    :display-header-title="false"
  >
    <delivery-not-available :data="data" />
  </modal>
</template>


<script>
  import DeliveryNotAvailable from './delivery-not-available/index.vue';


  export default {
    name: 'DeliveryNotAvailableModal',

    components: {
      DeliveryNotAvailable
    }
  };
</script>
